import type { GridRowId } from '@mui/x-data-grid-pro';
import type { TableRowType } from '../../../grid/reduxStore/table.types';

import TextEditorForTableBlock from './TextEditorForTableBlock.tsx';
import { useMemo } from 'react';
import { isJson } from '../../../../../utils/isJson.ts';
import type { PreviewVariablesContextType } from '../../../../../providers/PreviewVariablesContext.tsx';

interface CustomTableCellProps {
  id: GridRowId;
  row: TableRowType;
  field: string;
  value: string;
  isPreview: boolean;
  isTemplate?: boolean;
  usePreviewVariables: () => PreviewVariablesContextType;
}

export const TipTapRenderCellPreview = ({ id, field, value, row, isPreview, usePreviewVariables, isTemplate }: CustomTableCellProps) => {
  const rowType = row.rowType.toLowerCase();
  const { variables } = usePreviewVariables();

  const documentContent = useMemo(() => (isJson(value) ? JSON.parse(value) : value), [value]);

  if (!id) {
    return <></>;
  }
  return (
    <div data-testid={`tiptap-render-cell-wrapper-${rowType}`} className={`editable-cell-wrapper editable-cell-${id} ${rowType}`}>
      <TextEditorForTableBlock
        isPreview={isPreview}
        isTemplate={isTemplate}
        editable={false}
        value={documentContent}
        field={field}
        id={id as string}
        variables={variables}
      />
    </div>
  );
};
